import React, { forwardRef } from 'react';
import { MoreHorizontal } from 'lucide-react';
import { cn } from '../../../lib/utils';

/**
 * OrkaTaskMenuButton — three-dot overflow menu trigger (PRD §5.1).
 *
 * THE More affordance. Visually + semantically distinct from MoveHandle.
 * Always renders a horizontal three-dot icon, never the six-dot grid.
 *
 *   <OrkaTaskMenuButton aria-label="Task actions" onClick={openMenu} />
 */
export const OrkaTaskMenuButton = forwardRef(function OrkaTaskMenuButton(
  { className, label = 'Task actions', size = 'md', ...rest },
  ref,
) {
  return (
    <button
      ref={ref}
      type="button"
      aria-label={label}
      data-orka-menu-button="true"
      data-testid="orka-menu-button"
      className={cn(
        'inline-flex items-center justify-center rounded-md shrink-0',
        'orka-text-tertiary hover:orka-text-primary',
        'hover:orka-surface-subtle',
        'orka-transition-colors orka-focus-ring',
        size === 'sm' ? 'w-5 h-5' : 'w-6 h-6',
        className,
      )}
      {...rest}
    >
      <MoreHorizontal width={size === 'sm' ? 14 : 16} height={size === 'sm' ? 14 : 16} aria-hidden="true" />
    </button>
  );
});

export default OrkaTaskMenuButton;
